// extracted by mini-css-extract-plugin
export var aiStarIcon = "_v6-2";
export var container = "_v6-4";
export var dismissButton = "_v6-3";
export var hasPaddingBottom = "_v6-6";
export var last = "_v6-e";
export var scrollbarThumb = "_v6-c";
export var scrollbarTrack = "_v6-b";
export var selected = "_v6-9";
export var spin = "_v6-1";
export var spinning = "_v6-0";
export var suggestionItem = "_v6-d";
export var suggestionsPanel = "_v6-5";
export var tonePill = "_v6-8";
export var tonesContainer = "_v6-7";
export var unselected = "_v6-a";